import { useMemo } from 'react';
import { Colors, Text } from '@mercator-gcp/grout';
import Dropdown from 'components/elements/Dropdown';
import DropdownItem from 'components/elements/Dropdown/DropdownItem';
import { KeywordDropdown } from 'components/widgets/KeywordDropdown';
import { useDashboardCompanyKeywordsAndExclusions } from 'state/dashboard';

const Companies = () => {
  const {
    updateKeywords: setGlobalKeywords,
    keywords: globalKeywords,
    updateExclusions: setGlobalExclusions,
    exclusions: globalExclusions,
    removeKeyword,
    removeExclusion,
  } = useDashboardCompanyKeywordsAndExclusions();

  const filterCount = useMemo(() => {
    const keywordCount = globalKeywords.split(',').filter((item) => item !== '').length;
    const exclusionCount = globalExclusions
      ? globalExclusions.split(',').filter((item) => item !== '').length
      : 0;
    const totalCount = keywordCount + exclusionCount;

    // Show count when there are keywords or exclusions
    return totalCount > 0 ? totalCount.toString() : '';
  }, [globalKeywords, globalExclusions]);

  return (
    <Dropdown title="Companies" filterCount={filterCount}>
      <DropdownItem>
        <Text.Small as="p" color={Colors.TextQuiet}>
          Search by companies who have been involved at any point in the project
        </Text.Small>
        <KeywordDropdown
          globalState={globalKeywords}
          setGlobalState={setGlobalKeywords}
          pluralText="companies"
          singularText="company"
          onRemoveItem={removeKeyword}
          placeholder="Search companies"
          showSearchIcon={false}
          inputLabel="company input"
        />
      </DropdownItem>
      <DropdownItem>
        <KeywordDropdown
          isExclusion
          globalState={globalExclusions || ''}
          setGlobalState={setGlobalExclusions}
          pluralText="company exclusions"
          singularText="company exclusion"
          onRemoveItem={removeExclusion}
          placeholder="Search companies"
          showSearchIcon={false}
          inputLabel="company input"
        />
      </DropdownItem>
    </Dropdown>
  );
};

export default Companies;
